class StoreMessage {
  constructor (
    id = undefined,
    content,
    type,
    categoryId,
    senderDeviceId,
    senderUserId,
    receiverDeviceId,
    receiverUserId,
    receiverChatGroupId,
    createdAt,
    color = undefined,
    received = false,
    read = false,
    readCount = undefined,
    totalRecipients = undefined
  ) {
    if (!Object.values(StoreMessage.SUPPORTED_MESSAGE_TYPES).includes(type)) {
      throw new Error(`[StoreMessage] Invalid 'type' received: ${type}`)
    }

    this.id = id
    this.content = content
    this.type = type
    this.categoryId = categoryId
    this.category = null
    this.senderDeviceId = senderDeviceId
    this.senderDevice = null
    this.senderUserId = senderUserId
    this.senderUser = null
    this.receiverDeviceId = receiverDeviceId
    this.receiverDevice = null
    this.receiverUserId = receiverUserId
    this.receiverUser = null
    this.receiverChatGroupId = receiverChatGroupId
    this.receiverChatGroup = null
    this.createdAt = new Date(createdAt)
    this.color = color
    // delivery/read receipts (read implies received)
    this.received = !!received || !!read
    this.read = !!read
    this.readCount = readCount != null ? Number(readCount) : undefined
    this.totalRecipients = totalRecipients != null ? Number(totalRecipients) : undefined
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      content: this.content,
      type: this.type,
      categoryId: this.categoryId,
      // senderDeviceId is read-only
      // senderUserId is read-only
      receiverDeviceId: this.receiverDeviceId,
      receiverUserId: this.receiverUserId,
      receiverChatGroupId: this.receiverChatGroupId
      // createdAt is read-only
    })
  }

  static FromNormalizedRESTModel ({
    id,
    content,
    type,
    categoryId,
    senderDeviceId,
    senderUserId,
    receiverDeviceId,
    receiverUserId,
    receiverChatGroupId,
    createdAt,
    color,
    received,
    read,
    readCount,
    totalRecipients
  }) {
    return new StoreMessage(
      id,
      content,
      type,
      categoryId,
      senderDeviceId,
      senderUserId,
      receiverDeviceId,
      receiverUserId,
      receiverChatGroupId,
      createdAt,
      color,
      received,
      read,
      readCount,
      totalRecipients
    )
  }

  toJSON () {
    return {
      id: this.id,
      content: this.content,
      type: this.type,
      categoryId: this.categoryId,
      senderDeviceId: this.senderDeviceId,
      senderUserId: this.senderUserId,
      receiverDeviceId: this.receiverDeviceId,
      receiverUserId: this.receiverUserId,
      receiverChatGroupId: this.receiverChatGroupId,
      createdAt: this.createdAt,
      color: this.color,
      received: this.received,
      read: this.read,
      readCount: this.readCount,
      totalRecipients: this.totalRecipients
    }
  }

  static FromJSON ({
    id,
    content,
    type,
    categoryId,
    senderDeviceId,
    senderUserId,
    receiverDeviceId,
    receiverUserId,
    receiverChatGroupId,
    createdAt,
    color,
    received,
    read,
    readCount,
    totalRecipients
  }) {
    return new StoreMessage(
      id,
      content,
      type,
      categoryId,
      senderDeviceId,
      senderUserId,
      receiverDeviceId,
      receiverUserId,
      receiverChatGroupId,
      createdAt,
      color,
      received,
      read,
      readCount,
      totalRecipients
    )
  }
}

StoreMessage.SUPPORTED_MESSAGE_TYPES = {
  TEXT: 'text'
}

export default StoreMessage
